import {
    DateComparisonType,
    TimeDirection,
    RelativeDateRange,
    InteractionType,
    EntityFilters,
    JobStatus,
} from '@servicetitan/application-data/marketing';
import { DateRange } from 'utils';

export interface EntityFiltersExtended extends EntityFilters {
    location: {
        locationZipCodes?: string[] | undefined;
        zones?: string[] | undefined;
        locationTags?: string[] | undefined;
    };
    job: {
        jobStatuses?: JobStatus[] | undefined;
        noJobsSince?: Date | undefined;
        noJobsSinceRelative?: RelativeDateRange | undefined;
        jobScheduled?: DateRange | undefined;
        jobScheduledRelative?: RelativeDateRange | undefined;
    };
    call: {
        noInboundCallsSince?: Date | undefined;
        noInboundCallsSinceRelative?: RelativeDateRange | undefined;
        noOutboundCallsSince?: Date | undefined;
        noOutboundCallsSinceRelative?: RelativeDateRange | undefined;
        noEmailsSince?: Date | undefined;
        noEmailsSinceRelative?: RelativeDateRange | undefined;
    };
}

export const dateComparisonTypeToText = new Map<DateComparisonType, string>([
    [DateComparisonType.Less, 'Less Than'],
    [DateComparisonType.Greater, 'Greater Than'],
    [DateComparisonType.Between, 'Between'],
    [DateComparisonType.Equal, 'Equal To'],
]);

export const timeDirectionToText = new Map<TimeDirection, string>([
    [TimeDirection.Future, 'In the Future'],
    [TimeDirection.Past, 'In the Past'],
]);

export const InteractionTypeToTextMap = new Map<InteractionType, string>([
    [InteractionType.Sent, 'Was sent'],
    [InteractionType.NotSent, 'Was not sent'],
    [InteractionType.Opened, 'Was opened'],
    [InteractionType.NotOpened, 'Was not opened'],
    [InteractionType.Clicked, 'Was clicked'],
    [InteractionType.NotClicked, 'Was not clicked'],
]);

export enum YesNoEnum {
    Yes = 'Yes',
    No = 'No',
}

export const relativeDateRangeValidator =
    (errorMessage1 = 'fill the period', errorMessage2 = 'second number should be more') =>
    (val?: RelativeDateRange) => {
        if (val && val.from === undefined) {
            return errorMessage1;
        }
        if (
            val &&
            val.comparison === DateComparisonType.Between &&
            val.from &&
            val.to === undefined
        ) {
            return errorMessage1;
        }
        if (val && val.comparison === DateComparisonType.Between && val.from! >= val.to!) {
            return errorMessage2;
        }
        return '';
    };
